var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"personal_info"}},[_c('div',{staticClass:"tabbar"},[_c('div',{staticClass:"isAcitve"},[_vm._v(" "+_vm._s(_vm.tabbarLabelC)+" ")])]),_c('div',{staticClass:"personal_info_content"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }